import React from 'react';
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogDescription,
} from 'components/shadcn/ui/dialog';
import { Button } from 'components/shadcn/ui/button';

const DeleteModal = ({ modalOpen, modalClose, onDelete }) => {
    return (
        <Dialog
            open={modalOpen}
            onOpenChange={(open) => {
                if (!open) modalClose();
            }}
        >
            <DialogContent className="mx-auto max-w-md">
                <DialogHeader>
                    <DialogTitle>Delete Site</DialogTitle>
                    <DialogDescription>
                        Are you sure you want to delete this site?
                    </DialogDescription>
                </DialogHeader>
                <div className="mt-4 flex justify-around">
                    <Button variant="outline" onClick={modalClose}>
                        Cancel
                    </Button>
                    <Button variant="destructive" onClick={onDelete}>
                        Delete
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default DeleteModal;
